Namespace 'Customer.Filters'

class Customer.Filters.TagsCardView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tabs/interactions/tags_card']
  className: 'filter-field-container filter-tags-container'

  events:
    'click .tags-filter-button': '_openModal'

  initialize: ({filter, newQuery, tags, editable}) ->
    @filter = filter
    @tags = tags
    @newQuery = newQuery
    @editable = editable

  render: ->
    @$el.html @template
    @_addSocialContentTagsView()
    @

  updateTags: ->
    @filter.updateIntelligentTags(@socialContentTagsView.getValues())

  _keepCustomerSessionAlive: ->
    Backbone.trigger 'customerSession:keepAlive'

  _addSocialContentTagsView: ->
    @_socialContentTagsViewBackwardsCompatibility()
    @socialContentTagsView?.remove()

    @socialContentTagsView = new Customer.Filters.TagsFilterView
      tagsByClientCode: @_tagsByCode()
      intelligentTags: @filter.get('query').intelligent_tags
      readOnly: !@editable
    @socialContentTagsView.render()

  _socialContentTagsViewBackwardsCompatibility: ->
    oldTags = @filter.get('query').tags || []
    intelligent_tags = @filter.get('query').intelligent_tags.primary_tags || []
    @filter.get('query').intelligent_tags.primary_tags = intelligent_tags.concat(oldTags)
    delete(@filter.get('query').tags)
    delete(@newQuery.tags)

  _openModal: ->
    @_keepCustomerSessionAlive()
    @modalView?.remove()
    @modalView = new Common.Modals.ModalView
      title: I18n.t('customer.dashboard.filters.creation.tags.selector_title')
      contentView: @socialContentTagsView
      size:
        width: 1022
        height: 472
      modalOptions:
        addClass: 'tags-filter-header'
    @modalView.render()
    @listenTo @modalView, 'modal:closed', @socialContentTagsView.clearIfCanceled

  _tagsByCode: ->
    tagsByCode = {}
    @tags.forEach((t) => tagsByCode[t.code] = t)
    tagsByCode
